import {Component} from "@/event/calendar/dom/Component.ts";
import {DayColumns, HasDayColumns, weekGridDays} from "@/event/calendar/days/DaysComponent.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {Coordinates, drawTextBadge, Rect, SnapCoordinates} from "@/event/calendar/Shapes.ts";
import {GRID_HEADER_FONT_SIZE, MONTH_GRID_OFFSET_X} from "@/event/calendar/Constants.ts";
import {dayHeaderLong, dayHeaderShort, dayHeaderTiny, weekdayName, weekdayShortName} from "@/event/calendar/Formating.ts";
import {CalendarView} from "@/event/calendar/CalendarModel.ts";
import {MIN_SNAP_DISTANCE} from "@/event/calendar/dom/ScrollComponent.ts";

export class DaysTopHeader extends Component implements HasDayColumns {
	public dayColumns: DayColumns;
	private view: CalendarView;

	constructor(view:CalendarView) {
		super();
		this.view = view;
	}

	protected drawBackground(dc: DrawingContext, area: Rect) {
		const fontFamily = dc.style.getPropertyValue("--font");
		const pillBg = dc.style.getPropertyValue("--cal-today-bg");
		const pillFg = dc.style.getPropertyValue("--cal-today-fg");
		const headerFg = dc.style.getPropertyValue("--cal-header-fg");
		dc.ctx.font = GRID_HEADER_FONT_SIZE + "px "+fontFamily;


		const ms = dc.ctx.measureText("x");	// to find baseline
		const textLineHeight = ms.fontBoundingBoxAscent + ms.fontBoundingBoxDescent;
		const baseline = Math.floor(((area.height - 1 - textLineHeight) / 2) + ms.fontBoundingBoxAscent + 1);

		//console.log("Drawing focused="+this.view.focused+" selected="+this.view.selected+" aligned = "+this.view.aligned);

		for (let col of this.dayColumns.days) {
			let dayName = col.width > 100 ? dayHeaderLong(col.date) : (col.width > 60 ? dayHeaderShort(col.date) : dayHeaderTiny(col.date));
			if (col.today) {
				drawTextBadge(dc.ctx, dayName, col.x + MONTH_GRID_OFFSET_X, baseline, 6, 1, pillBg, pillFg);
			} else {
				dc.ctx.fillStyle = headerFg;
				dc.ctx.fillText(dayName, col.x + MONTH_GRID_OFFSET_X, baseline);
			}
			/*if (col.selected) {
				dc.ctx.fillStyle = "#3E9ADE";
				dc.ctx.beginPath();
				dc.ctx.ellipse(col.x + col.width - MONTH_GRID_OFFSET_X, baseline, 2.5, 2.5, 0, 0, Math.PI * 2);
				dc.ctx.fill();
			}
			if (col.aligned) {
				dc.ctx.fillStyle = "#DE3E9A";
				dc.ctx.beginPath();
				dc.ctx.ellipse(col.x + col.width - MONTH_GRID_OFFSET_X - 7, baseline, 2.5, 2.5, 0, 0, Math.PI * 2);
				dc.ctx.fill();
			}*/
		}

		dc.ctx.strokeStyle = dc.style.getPropertyValue("--cal-header-day-separ");
		drawVerticalLines(dc.ctx, this.dayColumns, area);
	}

	getSnapPosition(x: number, y: number, xPositiveDir?:boolean, yPositiveDir?:boolean): SnapCoordinates | null {
		const width = this.width / weekGridDays(this.view)
		const lowerSnapX = Math.floor(x / width) * width;
		const higherSnapX = Math.ceil(x / width) * width;
		const lowerDistance = Math.abs(x - lowerSnapX);
		const higherDistance = Math.abs(x - higherSnapX);
		let snapX;
		if (lowerDistance < MIN_SNAP_DISTANCE && higherDistance >= MIN_SNAP_DISTANCE) snapX = lowerSnapX;
		else if (higherDistance < MIN_SNAP_DISTANCE && lowerDistance >= MIN_SNAP_DISTANCE) snapX = higherSnapX;
		else snapX = xPositiveDir ? higherSnapX : lowerSnapX;
		if (x === snapX) return null;
		return { x: snapX, y: 0, snapX:true, snapY: false };
	}
}

export function drawVerticalLines(ctx: CanvasRenderingContext2D, cols:DayColumns, area:Rect):void {
	for (let col of cols.days) {
		let x = col.x + col.width;
		if (x < (area.x + area.width - 2) && x > (area.x + 2)) {
			x = Math.round(x + 0.5) - 0.5;
			ctx.beginPath();
			ctx.moveTo(x, area.y);
			ctx.lineTo(x, area.y + area.height);
			ctx.stroke();
		}
	}
}